import SuccessMessage from 'common/SuccessMessage';
import Heading from 'emails/Heading';
import LinkButton from 'emails/LinkButton';

import React from 'react';

import EmailLayout from './EmailLayout/EmailLayout';
import { Section, Row, Column, Img, Text, Button } from '@react-email/components';

const InfoCell = ({ label, value }) => {
    return (
        <Text style={{
            color: '#3E3E4A',
            fontSize: '16px',
            fontWeight: 400,
            marginRight: '10px',
        }}><strong>{label}:</strong> {value}</Text>
    );
};

const PaymentRequest = ({ url, amount, drName, service, date, patientName, drImage, businessId, extraQueryParams }) => {
    const buildHref = () => {
        let href = `${url}?business_id=${businessId}`;
        if (extraQueryParams && typeof extraQueryParams === 'object') {
            Object.entries(extraQueryParams).forEach(([key, value]) => {
                if (value !== undefined && value !== null) {
                    href += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
                }
            });
        }
        return href;
    };
    return (
        <EmailLayout>
            <div className="heading">
                <SuccessMessage style={{ color: '#95CFD3' }}>Payment Request</SuccessMessage>
                <Heading style={{ marginTop: '10px' }}>Hi, {patientName}! Here is the payment request for your office visit:</Heading>
            </div>

            <Section style={{ textAlign: 'center', padding: '20px', width: '80%' }}>
                <Row style={{ display: 'inline-block', textAlign: 'left' }}>
                    {/* Doctor Image */}
                    {drImage && (
                        <Column style={{ verticalAlign: 'middle' }}>
                            <Img
                                src={drImage}
                                alt="Doctor"
                                width="80"
                                height="80"
                                style={{ borderRadius: '50%' }}
                            />
                        </Column>
                    )}

                    {/* Doctor Details */}
                    <Column style={{ paddingLeft: '20px', verticalAlign: 'middle' }}>
                        {drName && (
                            <InfoCell label="Doctor" value={drName} />
                        )}
                        <InfoCell label="Service" value={service} />
                        <InfoCell label="Total Due" value={`$${amount}`} />
                        <InfoCell label="Date" value={date} />
                    </Column>
                </Row>
            </Section>

            <Section style={{ textAlign: 'center', marginTop: '20px' }}>
                <Button
                    href={buildHref()}
                    style={{
                        padding: '10px 30px',
                        backgroundColor: '#FF5F39',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '28px',
                        cursor: 'pointer',
                        fontSize: '12px',
                        fontWeight: 500,
                        fontFamily: 'Poppins, sans-serif',
                    }}
                >
                    Pay Now
                </Button>
            </Section>
        </EmailLayout>
    );
};

export default PaymentRequest;
